const Emoji_S = {
    ':sad_1': { id: 417, width: 20, height: 20 },
    ':sad_2': { id: 418, width: 43, height: 27 },
    ':sad_3': { id: 419, width: 18, height: 18 },
    ':sad': { id: 26, width: 18, height: 18 },
    ':sadbye': { id: 3, width: 26, height: 18 },
    ':saddam': { id: 420, width: 18, height: 25 },
    ':samurai': { id: 44, width: 18, height: 18 },
    ':santa_1': { id: 422, width: 24, height: 27 },
    ':santa': { id: 423, width: 20, height: 22 },
    ':schmoll': { id: 424, width: 20, height: 20 },
    ':schnauz': { id: 425, width: 20, height: 20 },
    ':scooter': { id: 426, width: 40, height: 33 },
    ':search': { id: 427, width: 38, height: 25 },
    ':shifty': { id: 428, width: 20, height: 20 },
    ':shit': { id: 429, width: 16, height: 16 },
    ':shock_1': { id: 430, width: 18, height: 19 },
    ':shock': { id: 33, width: 18, height: 18 },
    ':shocked': { id: 432, width: 18, height: 18 },
    ':shocking': { id: 434, width: 18, height: 18 },
    ':shok': { id: 435, width: 20, height: 20 },
    ':showoff': { id: 436, width: 40, height: 21 },
    ':shrug': { id: 437, width: 32, height: 20 },
    ':shuriken': { id: 438, width: 37, height: 24 },
    ':shutup': { id: 439, width: 20, height: 20 },
    ':sick_1': { id: 440, width: 18, height: 18 },
    ':sick': { id: 441, width: 20, height: 20 },
    ':slap': { id: 442, width: 49, height: 23 },
    ':sleep_1': { id: 443, width: 38, height: 23 },
    ':sleep': { id: 444, width: 20, height: 20 },
    ':sleepy': { id: 47, width: 20, height: 20 },
    ':sly': { id: 446, width: 20, height: 20 },
    ':sm_clap': { id: 448, width: 40, height: 27 },
    ':sm_crazy': { id: 449, width: 20, height: 27 },
    ':sm_fool': { id: 450, width: 29, height: 23 },
    ':sm_haha': { id: 451, width: 28, height: 20 },
    ':sm_lol': { id: 463, width: 28, height: 23 },
    ':sm_victory': { id: 467, width: 28, height: 23 },
    ':sm_yahoo': { id: 468, width: 42, height: 27 },
    ':smartass': { id: 447, width: 25, height: 22 },
    ':smile_1': { id: 452, width: 18, height: 18 },
    ':smile': { id: 453, width: 20, height: 20 },
    ':smilewink': { id: 454, width: 22, height: 22 },
    ':smilie_osx': { id: 459, width: 17, height: 18 },
    ':smilie_palm': { id: 460, width: 12, height: 18 },
    ':smilie_tux': { id: 461, width: 15, height: 18 },
    ':smilie_xp': { id: 462, width: 18, height: 16 },
    ':smilie': { id: 458, width: 25, height: 25 },
    ':smilie1': { id: 455, width: 18, height: 18 },
    ':smilie3': { id: 456, width: 18, height: 18 },
    ':smilie4': { id: 457, width: 18, height: 18 },
    ':smoke_1': { id: 464, width: 21, height: 20 },
    ':smoke': { id: 465, width: 46, height: 20 },
    ':smoker': { id: 13, width: 18, height: 18 },
    ':smoking': { id: 609, width: 18, height: 18 },
    ':smurf': { id: 466, width: 20, height: 24 },
    ':sneaktongue': { id: 469, width: 20, height: 20 },
    ':sneaky': { id: 470, width: 20, height: 20 },
    ':snorkel': { id: 471, width: 18, height: 25 },
    ':sombrero2': { id: 472, width: 30, height: 25 },
    ':sorry': { id: 473, width: 24, height: 22 },
    ':sp_ike': { id: 475, width: 22, height: 22 },
    ':spidy': { id: 474, width: 18, height: 18 },
    ':sq_yellow_angry': { id: 476, width: 18, height: 18 },
    ':sq_yellow_arg': { id: 477, width: 18, height: 18 },
    ':sq_yellow_biggrin': { id: 478, width: 18, height: 18 },
    ':sq_yellow_blink': { id: 479, width: 18, height: 18 },
    ':sq_yellow_blush': { id: 480, width: 18, height: 18 },
    ':sq_yellow_closedeyes': { id: 481, width: 18, height: 18 },
    ':sq_yellow_cool': { id: 482, width: 18, height: 18 },
    ':sq_yellow_cry': { id: 483, width: 18, height: 18 },
    ':sq_yellow_dry': { id: 484, width: 18, height: 18 },
    ':sq_yellow_glare': { id: 485, width: 18, height: 18 },
    ':sq_yellow_goodmood': { id: 486, width: 18, height: 18 },
    ':sq_yellow_happy': { id: 487, width: 18, height: 18 },
    ':sq_yellow_huh': { id: 488, width: 18, height: 18 },
    ':sq_yellow_laugh': { id: 489, width: 18, height: 18 },
    ':sq_yellow_mellow': { id: 490, width: 18, height: 18 },
    ':sq_yellow_notti': { id: 491, width: 18, height: 18 },
    ':sq_yellow_ohmy': { id: 492, width: 18, height: 18 },
    ':sq_yellow_playful': { id: 493, width: 18, height: 18 },
    ':sq_yellow_sad': { id: 494, width: 18, height: 18 },
    ':sq_yellow_sick': { id: 495, width: 18, height: 18 },
    ':sq_yellow_smile': { id: 496, width: 18, height: 18 },
    ':sq_yellow_specky': { id: 497, width: 18, height: 18 },
    ':sq_yellow_surprise': { id: 498, width: 18, height: 18 },
    ':sq_yellow_tongue': { id: 499, width: 18, height: 18 },
    ':sq_yellow_unhappy': { id: 500, width: 18, height: 18 },
    ':sq_yellow_unsure': { id: 501, width: 18, height: 18 },
    ':sq_yellow_wink': { id: 502, width: 18, height: 18 },
    ':strongsad': { id: 503, width: 18, height: 18 },
    ':suck': { id: 504, width: 18, height: 18 },
    ':sumo': { id: 505, width: 30, height: 27 },
    ':sun_smiley': { id: 506, width: 31, height: 31 },
    ':super': { id: 507, width: 26, height: 28 },
    ':superlol': { id: 508, width: 15, height: 15 },
    ':surrender': { id: 509, width: 28, height: 20 },
    ':suspect': { id: 510, width: 20, height: 20 },
    ':sweatdrop': { id: 511, width: 18, height: 18 },
}

export default Emoji_S
